import StatsBarIcon from "./StatsBarIcon.mjs";

export default class MyAssetIcon extends StatsBarIcon {}
